import React from 'react';
import Navigation from '../components/Navigation';
import Hero from '../components/Hero';
import About from '../components/About';
import Services from '../components/Services';
import Features from '../components/Features';
import Benefits from '../components/Benefits';
import Testimonials from '../components/Testimonials';
import Owner from '../components/Owner';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import FloatingButtons from '../components/FloatingButtons';

const CCTVPage = () => {
  return (
    <div className="CCTVPage">
      <Navigation />
      <Hero />
      <About />
      <Services />
      <Features />
      <Benefits />
      <Testimonials />
      <Owner />
      <Contact />
      <Footer />
      <FloatingButtons />
    </div>
  );
};

export default CCTVPage;

